export default "__VITE_ASSET__0bb9bddb__"